import { defineComponent } from 'vue'
import './style.sass'
import {ref, onBeforeMount } from 'vue'
import axios from '@/axios'
import { host } from '@/const'
import MobileFixedMenu from './components/MobileFixedMenu/MobileFixedMenu'

export default defineComponent({

  setup() {
    const copyright = ref(null)
    onBeforeMount(async() => {
      try {
        if (copyright.value === null) {
          copyright.value = (await axios.get(`${host}/api/v1/frontend`)).data ? (await axios.get(`${host}/api/v1/frontend`)).data.copyright : null
        }
      } catch (e) {
        // console.log(e)
      }
    })
    return () => {
      return (
        <div class="footer">
          <div class="container">
            <div class="footer-desktop">
              <div class="footer-top main-container">
                <div class="footer-top-elem-column footer-top-elem-column-first">
                  <div class="footer-top-elem-column-title">Режим работы</div>
                  <div class="footer-top-elem-column-list">
                    <div class="footer-top-elem-column-list-item">
                      <div class="first-elem-img"></div>
                      <div class="first-elem-content">
                        <span>Офис продаж</span>
                        <span>09:00-18:00</span>
                      </div>
                    </div>
      
                    <div class="footer-top-elem-column-list-item">
                      <div class="second-elem-img"></div>
                      <div class="second-elem-content">
                        <span>Приём заявок</span>
                        <a href="tel:88003331148" class="main-phone">
                          <div>
                            <span>8 (800)</span>
                            <span>333-11-48</span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
      
                <div class="footer-top-elem-column footer-top-elem-column-two">
                  <div class="footer-top-elem-column-title">Наш адрес</div>
                  <div class="footer-address">119435, г. Москва, Каширское шоссе, к2с12, офис 12-302</div>
                </div>
                <div class="footer-top-elem-column footer-top-elem-column-three">
                  <div class="payment-variants">
                    <div class="payment-variants-image payment-variants-image-0"></div>
                    <div class="payment-variants-image payment-variants-image-1"></div>
                    <div class="payment-variants-image payment-variants-image-2"></div>
                    <div class="payment-variants-image payment-variants-image-3"></div>
                  </div>
                </div>
              </div>
              <div class="footer-bottom main-container">
                <p>{{ copyright }}</p>
                <div class="no-offer">
                  <p>Информация на сайте о технических характеристиках, наличии на складе, стоимости и изображениях товаров не является публичной офертой.</p>
                  <p>Все изображения, размещенные на сайте, зарегистрированы в "Российском авторском обществе". Копирование и использование изображений возможно только <a href="mailto:press@cable.ru?subject=Запрос на соглашение&amp;body=Здравствуйте!">с разрешения правообладателя</a></p>
                </div>
                <div class="no-offer">
                  <p>Реализация товаров, размещенных в каталоге на сайте, не является дистанционной торговлей и осуществляется по предварительному согласованию наименования, эксплуатационных и технических
                  <br />характеристик, наличия и количества на основании <a target="_blank" href="https://cable.ru/documents.php">договора Оферты</a> и/или договоров, заключенных в письменной форме.</p>
                </div>
              </div>
            </div>
            <MobileFixedMenu/>
          </div>
        </div>
      )
    }
  }
})